import { Card, CardContent, CardHeader, Stack, Typography } from "@altimateai/lego";
import { CopyButton } from "@/components/copyButton";

interface SettingsCardProps {
  cardTitle: string;
  cardText: string;
  copyText: string;
}

const SettingsCard = ({ cardTitle, cardText, copyText }: SettingsCardProps) => {
  const cardId = `settings-card-${cardTitle.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <Card className="al-w-1/2">
      <CardHeader id={cardId}>
        <Typography variant="section-heading">{cardTitle}</Typography>
      </CardHeader>
      <CardContent>
        <Stack direction="column" align="baseline">
          <Typography variant="body" className="al-text-dark-gray">
            <span aria-describedby={cardId}>{cardText}</span>
          </Typography>
          <div
            role="textbox"
            aria-label={cardTitle}
            aria-readonly="true"
            className="al-bg-base-surface al-p-4 al-w-full al-rounded-md al-mb-2"
          >
            {copyText}
          </div>
          <CopyButton value={copyText} aria-label={`Copy ${cardTitle.toLowerCase()}`} />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default SettingsCard;
